/** Sum material line-item totals from project.materials array (or legacy numeric). */
export const getMaterialsBudget = (materials) => {
  if (!Array.isArray(materials)) {
    const n = parseFloat(materials);
    return Number.isFinite(n) ? n : 0;
  }
  return materials.reduce((sum, mat) => sum + parseFloat(mat?.total || 0), 0);
};

/** Services-only budget: plannerServiceValue when set, else projectTotal minus materials. */
export const getServiceBudget = (project) => {
  const mat = getMaterialsBudget(project?.materials);
  const psv = project?.plannerServiceValue;
  if (psv != null && psv !== "") {
    return parseFloat(psv) || 0;
  }
  return Math.max(0, (parseFloat(project?.projectTotal) || 0) - mat);
};
